
import { Component, OnInit, computed, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { BaseMenuItem, MenuItem, OfMenuTypePipe } from '@teamfoster/sdk/menu-ngrx';
import { JsonLdComponent } from 'src/app/seo/components/json-ld/json-ld.component';
import { SocialChannel } from 'src/app/social-media/models';
import { Department, Location } from 'src/app/location/models';
import { Button, LinkComponent } from '@teamfoster/sdk/button';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [FromDictionaryPipe, JsonLdComponent, LinkComponent, OfMenuTypePipe]
})
export class FooterComponent implements OnInit {
  private dict = new FromDictionaryPipe(this.lang);

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  menuEnd = input<MenuItem[]>([]);
  menuMain = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  locations = input<Location[]>([]);
  schema = input<any>({
    '@context': 'http://schema.org',
    '@type': this.dict.transform('footer-json-ld-meta-type'),
    'name': this.dict.transform('meta-titel'),
    'url': this.domain,
    'logo': `${this.domain}/assets/gfx/logo-coda-black.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': [],
  });

  year = new Date().getFullYear();

  centralLocation$ = computed(() => {
    const locations = this.locations();

    return locations.find(l => l.id == 1); // 1 == id of central location
  });

  thisDayNumber$ = computed(() => new Date().getDay());

  constructor(
    private store: Store,
    private lang: LanguageService
  ) {}

  ngOnInit(): void {
    this.socials().forEach(s => {
      const socialLink = s; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }

  getOpeningTime(department: Department) {
    const date = department?.openingTimes.find(a => a.day === this.thisDayNumber$());

    return date ? date.openingTimes : '- ';
  }

  buttonLink(menuItem: MenuItem): Button {
    return {
      text: menuItem.title,
      url: menuItem.url || '',
      routerLink: menuItem.routerLink,
      fragment: menuItem.fragment,
      queryParams: menuItem.queryParams,
    };
  }
}
